import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth-service';
import {
  RejectionReasonDTO,
  RejectionReasonResultSet,
} from '../../pages/admin-dashboard/rejection-reasons/rejection-reason.model';

@Injectable({
  providedIn: 'root',
})
export class RejectionReasonService {
  private http = inject(HttpClient);
  private authService = inject(AuthService);
  private API = environment.pharmacyMgtApiUrl;

  createRejectionReason(dto: RejectionReasonDTO) {
    const token = this.authService.getAccessToken();

    let headers = new HttpHeaders();

    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }

    return this.http.post(`${this.API}/orders/rejection/reasons`, dto, { headers });
  }

  getAllRejectionReason(
    lang: 'ar' | 'en',
    params: {
      pageNum?: number;
      pageSize?: number;
      orderBy?: 'TITLE' | 'CREATION_DATE' | 'LAST_MODIFICATION_DATE';
      orderDir?: 'ASC' | 'DESC';
      quickSearch?: string;
      createdOnFrom?: string;
      createdOnTo?: string;
      lastModifiedOnFrom?: string;
      lastModifiedOnTo?: string;
    },
  ) {
    const token = this.authService.getAccessToken();

    let headers = new HttpHeaders();

    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    headers = headers.set('Accept-Language', lang);
    let httpParams = new HttpParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        httpParams = httpParams.set(key, value.toString());
      }
    });

    return this.http.get<RejectionReasonResultSet>(`${this.API}/orders/rejection/reasons`, {
      headers,
      params: httpParams,
    });
  }
  updateRejectionReason(reasonId: number, dto: RejectionReasonDTO) {
    const token = this.authService.getAccessToken();

    let headers = new HttpHeaders();

    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }

    return this.http.put(`${this.API}/orders/rejection/reasons/${reasonId}`, dto, { headers });
  }

  deleteRejectionReason(reasonId: number) {
    const token = this.authService.getAccessToken();

    let headers = new HttpHeaders();

    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }

    return this.http.delete(`${this.API}/orders/rejection/reasons/${reasonId}`, { headers });
  }
}
